import React from "react";
import { useMediaQuery } from "@mui/material";
import { useEffect } from "react";
import { getAllServiceRequestAction } from "../../../../store/services/actions";
import { useDispatch, useSelector } from "react-redux";
import { Button, Table } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import {
  addToCartRequestActions,
} from "../../../../store/cart/actions";

const Services = () => {
  const { service, cart, auth } = useSelector((state) => state);
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const dispatch = useDispatch();
  const isTablet = useMediaQuery("(max-width: 960px)");
  const { cartId } = useParams();

  const clientServices = cart?.selected?.data?.client?.subscription?.reference?.services

  useEffect(() => {
    getAllServiceRequestAction("?")(dispatch);
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "servicename",
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Price (RWF)",
      dataIndex: "price",
      render: (text, record) => {
        const isServiceIncluded =
          clientServices && clientServices.includes(record.key);

        return (
          <span
            style={{
              textDecoration: "none",
              color: isServiceIncluded ? "gray" : "inherit",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "",
      dataIndex: "action",
      render: (text, record) => (
        <Button
          onClick={() => addToCart(record)}
          disabled={selectedRowKey !== record.key}
          loading={cart?.isUpdating && selectedRowKey === record.key}
        >
          Add to cart
        </Button>
      ),
    },

  ];

  const addToCart = async (record) => {
    if (auth?.token && cartId) {
      await addToCartRequestActions(auth?.token, cartId, {
        servicesToAdd: [record?.key],
      }, "Service added to cart")(dispatch);
    }
  };

  const handleRowSelection = (record) => {
    if (selectedRowKey === record.key) {
      setSelectedRowKey(null);
    } else {
      setSelectedRowKey(record.key);
    }
  };

  const dataToDisplay = service?.all?.data?.map((d) => {
    return {
      key: d?._id,
      servicename: d?.servicename,
      category: d?.category_id?.categoryname,
      price: parseInt(d?.amount)?.toLocaleString(),
    };
  });

  return (
    <div className="card">
      <div className="card-body">
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={dataToDisplay}
            rowSelection={{
              selectedRowKey,
              type: "radio",
              onSelect: handleRowSelection,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Services;
